import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["elementWrapper"];

  appendMain() {
    const main = document.querySelector('main')

    const element = this.elementWrapperTarget.children[0]
    const clone = element.cloneNode(true);

    const newElement = main.appendChild(clone)
    newElement.classList.remove('hidden')
  };

  removeMain() {
    this.element.remove()
  };
};
